import en from './languages/en';
import de from './languages/de';

const config: CVT.Config = {
  projectName: 'Legacy Pet',
  featureFlags: {
    googleSSO: true,
    microsoftSSO: false,
    appleSSO: false,
    metaSSO: true,
    translations: false,
    notifications: true,
    darkMode: false,
    quickAddMode: false,
  },
  theme: {
    defaultMode: 'light',
    drawerWidth: 240,
    disableRipple: true,
    elevation: 0,
  },
  language: {
    dictionaries: {
      en,
      de,
    },
    languageLabelMap: {
      en: 'English',
      de: 'Deutsche',
    },
    supportedLanguages: ['en', 'de'],
    defaultLanguage: 'en',
    defaultDictionary: en,
  },
  defaultPermissions: {
    tributes: {
      list: false,
      view: true,
      create: true,
      edit: false,
      delete: false,
      myTributes: false,
    },
    users: {
      list: false,
      view: true,
      create: false,
      edit: false,
      delete: false,
      invite: false,
    },
    gifts: {
      list: false,
      view: true,
      create: true,
      edit: false,
      delete: false,
    },
  },
  dialogs: [
    'authentication',
    'inviteTeamMember',
    'mediaLightbox',
    'savingTribute',
    'creatingGift',
    'createTributeCard',
    'faq',
    'help',
  ],
};

export default config;
